/* eslint-disable require-jsdoc */
import React from 'react';
import PropTypes from 'prop-types';
import {isValid} from '../utils/validate';


const TilePlayer = (props) => {
  const band = props.band;
  if (band === undefined || !isValid(band.spotifyId)) {
    return null;
  }
  return (
    <div className='hearby-tile-player'>
      <iframe
        src={`https://open.spotify.com/embed/artist/${band.spotifyId}`}
        loading='lazy'
        width='100%'
        height='80'
        frameBorder='0'
        allowtransparency='true'
        allow='encrypted-media'
      ></iframe>
    </div>);
};

TilePlayer.propTypes = {
  band: PropTypes.object,
};

export default TilePlayer;
